export default __webpack_public_path__ + "static/media/denizc7.99b380fc.jpg";